import { Box, BoxProps, ColorOptions, IconButton, ModalDialog, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useCallback, useState } from 'react'
import { FlatList } from 'react-native-gesture-handler'
import { TextProps } from 'react-native-svg'
import { ModelDialogHeaders } from '../../screens/FraudAndRiskManagement/ModalDialogContainer'

interface ExpandableTextViewProps {
  text: string
  rowData: any
  commentsData?: Array<{ key: string; heading: string }>
  modelTitle?: any
  textStyle?: any
  dialogStyle?: BoxProps
  backgroundColor?: ColorOptions
  showDefaultExpandedView?: boolean
}
export const ExpandableTextView = ({
  text,
  rowData,
  commentsData = [],
  modelTitle = 'Comments',
  textStyle = DEFAULT_TEXT_STYLE,
  dialogStyle,
  showDefaultExpandedView = false,
  backgroundColor = 'WHITE',
}: ExpandableTextViewProps) => {
  const [isEllipsize, setEllipsize] = useState(false)
  const [showExpandableView, setShowExpandableView] = useState(false)
  const onLayout = useCallback(
    ({
      nativeEvent: {
        target: { offsetWidth, scrollWidth },
      },
    }: any) => {
      setEllipsize(offsetWidth < scrollWidth)
    },
    [],
  )

  return (
    <Box flexDirection={'row'} alignItems={'center'}>
      <Box f={1}>
        <Text onLayout={onLayout} numberOfLines={1} {...textStyle}>
          {text}
        </Text>
      </Box>
      {(showDefaultExpandedView || isEllipsize) && (
        <IconButton id={'EYE_WATCH'} onPress={() => setShowExpandableView(true)} width={16} color="PRIMARY" />
      )}
      <ModalDialog
        show={showExpandableView}
        onDismiss={() => setShowExpandableView(false)}
        type={'CenteredWrap'}
        underlayBackground="TRANSPARENT">
        <ExpandableTextContainer
          text={text}
          rowData={rowData}
          commentsData={commentsData}
          onDismiss={() => setShowExpandableView(false)}
          modelTitle={modelTitle}
          dialogStyle={dialogStyle}
          backgroundColor={backgroundColor}
        />
      </ModalDialog>
    </Box>
  )
}

const Item = ({ title, value }) => {
  return (
    <Box flexDirection={'row'} p={8} alignItems={'center'} width={'100%'} flex={1}>
      <ModBox minWidth={180} alignSelf={'flex-start'} show={title?.length > 0}>
        <Text color="PRIMARY" fontFamily="jiotype-medium" fontSize={14}>
          {title}:
        </Text>
      </ModBox>
      <Spacer direction="horizontal" size={16} />
      <Box flex={1}>
        <Text color="BLACK_21" fontFamily="jiotype-medium" fontSize={12}>
          {value}
        </Text>
      </Box>
    </Box>
  )
}

const ExpandableTextContainer = ({ onDismiss, text, commentsData, rowData, modelTitle, dialogStyle,backgroundColor="WHITE" }: any) => {
  const renderItem = ({ item }) => <Item title={item.heading} value={rowData?.[item?.key]} />
  return (
    <Box width={'90vw'} borderRadius={8} height={'90vh'} backgroundColor={backgroundColor} overflow={'hidden'} {...dialogStyle}>
      <ModelDialogHeaders onDismiss={onDismiss} title={modelTitle} />
      <Box padding={16} nativeID="hv-scroll" flex={1}>
        <FlatList data={commentsData} renderItem={renderItem} keyExtractor={(item) => item.id} numColumns={2} />
      </Box>
    </Box>
  )
}

const DEFAULT_TEXT_STYLE = { color: 'BLACK_21', fontFamily: 'jiotype-medium', fontSize: 10 } as TextProps
